import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:0,type:'culture'},
    home:{
      title:'安全理念',
      num:0,
      img:'img/a2.png',
      renwuClass:'',
      zdata:[
        {hover:'on',end:'',animateName:'renwu1',duration:'1.1',icon:'img/jt1.png',title:'安全理念',path:'production1',position:{x:'-50%',y:'0'},web:{x:'-50%',y:0}},
        {hover:'',end:'',animateName:'renwu2',icon:'img/jt1.png',title:'职业健康生产方针',duration:'3',path:'production2',position:{x:'-50%',y:'-4vw'},web:{x:'-50%',y:'-4vw'}},
        {hover:'',end:'',animateName:'renwu3',icon:'img/jt1.png',title:'职业健康生产方针',duration:'6',path:'production3',position:{x:'-16.5vw',y:'-13vw'},web:{x:'-32vw',y:'-23vw'}},
        {hover:'',end:'',animateName:'renwu4',icon:'img/jt1.png',title:'三个预防',duration:'4',path:'production4',position:{x:'22.8vw',y:'-25.2vw'},web:{x:'43vw',y:'-45vw'}},
        {hover:'',end:'',animateName:'renwu5',icon:'img/jt.png',title:'三 常',duration:'1',path:'production5',position:{x:'-12vw',y:'-25.2vw'},web:{x:'-22vw',y:'-45vw'}},
        {hover:'',end:'',animateName:'renwu6',icon:'img/jt1.png',title:'三 常',duration:'1',path:'production6',position:{x:'-22vw',y:'-25.2vw'},web:{x:'-45vw',y:'-45vw'}}
      ]
    }
  },
  mutations: {
    setFooter(state,data){
      if(data){
        if(data.page){
          state.footerData.page=data.page;
        }
        if(data.index){
          for(var i=0;i<state.nav.length;i++){
            state.nav[i].click="";
          }
          state.nav[data.index].click="on";
        }
        if(data.child){
           for(var i=0;i<state.nav.length;i++){
            state.nav[i].click="";
          }
          state.nav[data.index].click="";
          state.nav[data.index-1].child=data.child;
        }else{
          state.nav[data.index-1].child=data.child;
        }
      }
    },
    setIdx(state,data){
      state.home.zdata.forEach(function(v,i){
        v.hover="";
        v.end="";
      });
      state.home.zdata[data.idx].hover="on";
      state.home.num=data.idx;
    },
    setCreate(state,data){
      state.home.zdata[data.idx].hover="";
      state.home.zdata[data.idx].end="end";
      state.home.title=state.home.zdata[data.idx].title;
      $('.lh-renwu .icon').css({'animation-play-state':'running'});
      $('.lh-renwu').css({'animation-duration':state.home.zdata[data.idx].duration+'s','animation-name':state.home.zdata[data.idx].animateName});
      if(data.idx===1){
        setTimeout(function(){
          state.home.renwuClass="one";
          state.home.img="img/figure1.png";
        },600);
        setTimeout(function(){
          state.home.renwuClass="two";
          state.home.img="img/a2.png";
        },state.home.zdata[data.idx].duration*1000);
      }else if(data.idx===2){
        state.home.renwuClass="three";
        state.home.img="img/figure.png";
        setTimeout(function(){
          state.home.renwuClass="four";
          state.home.img="img/a2.png";
        },1800);
        setTimeout(function(){
          state.home.renwuClass="five";
          state.home.img="img/figure.png";
        },3600);
        setTimeout(function(){
          state.home.renwuClass="sex";
          state.home.img="img/a2.png";
        },state.home.zdata[data.idx].duration*1000);
      }else if(data.idx===3){
        state.home.renwuClass="a1";
        state.home.img="img/figure1.png";
        setTimeout(function(){
          state.home.renwuClass="sex";
          state.home.img="img/a2.png";
        },state.home.zdata[data.idx].duration*1000);
      }else if(data.idx===4){
        state.home.renwuClass="a1";
        state.home.img="img/figure1.png";
        setTimeout(function(){
          state.home.renwuClass="sex";
          state.home.img="img/a2.png";
        },state.home.zdata[data.idx].duration*1000);
      }
      setTimeout(function(){
        $('.lh-renwu .icon').css({'animation-play-state':'paused'});
        var time=100;
        console.log(data.idx);
        if(data.idx!=2&&data.idx!=5){
          $('.lh-homes').addClass('showTitle');
          time=1450;
        }
        setTimeout(function(){
          if(data.idx<5){
           state.home.zdata[data.idx+1].hover="on";
          }
           state.home.num=data.idx+1;
           data.$router.replace({ path: state.home.zdata[data.idx].path});
        },time);
      },state.home.zdata[data.idx].duration*1000);
    }
  },
  actions: {
  },
  modules: {
  }
})
